import { useTranslation } from 'react-i18next';
import { ButtonPropsWithLabel } from 'src/components/Dialog';

import { BlockingReasonRow } from './BlockingReasonRow';

// Mock: waiver blocking reason UI is a placeholder for future implementation.
// Once the waiver API exists, this component will fetch real data.
export function WaiverRequiredReason({
  _userId,
  inlineActions = false,
}: {
  _userId: string;
  inlineActions?: boolean;
}) {
  const { t } = useTranslation('translation', { keyPrefix: 'checkinBlocker' });

  const actions = [
    {
      label: t('actions.viewDocument'),
      variant: 'bordered',
    },
    {
      label: t('actions.override'),
      variant: 'borderless',
    },
  ] as ButtonPropsWithLabel[];

  return (
    <BlockingReasonRow
      title={t('blockingReasons.waiverRequired.title')}
      message={t('blockingReasons.waiverRequired.message')}
      actions={inlineActions ? actions : undefined}
    />
  );
}
